import {
    Handle,
    Position,
    useReactFlow,
} from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const StartNode = (node) => {
    const { type, data, selected } = node;
    const { getEdges } = useReactFlow();

    const showButton = useMemo(() => {
        if (type === 'endNode') return true;
        const edges = getEdges()
        const isConnectd = edges.find(edge => edge.source === node.id);
        return !isConnectd;
    }, [node, getEdges])

    return (
        <>
            <Handle type="source" position={Position.Right} />
            <div className={`conversation-node ${type} ${selected ? 'active' : ''}`}>
                <div className='title'>
                    <p><i className="k-icon k-i-play"></i>{data.suggestedText}</p>
                    <button style={{ visibility: showButton ? 'visible' : 'hidden' }}
                        onClick={(event) => {
                            event.preventDefault();
                            data.openContextMenu(event, node);
                        }}
                    >
                        <i className="k-icon k-i-more-horizontal"></i>
                    </button>
                </div>
            </div>
        </>
    );
}

export const EndNode = (node) => {
    const { data } = node;
    const { t } = useTranslation('chatbot', { keyPrefix: 'conversationsConfig.conversations' })

    return (
        <>
            <Handle type="target" position={Position.Left} />
            <div className='limit-node endNode'>
                <p>{t("end")}</p>
                <button
                    onClick={(event) => {
                        event.preventDefault();
                        data.openContextMenu(event, node);
                    }}
                >
                    <i className="k-icon k-i-more-horizontal"></i>
                </button>
            </div>
        </>
    );
}

export const ConversationNode = (node) => {
    const { type, data, selected } = node;

    let title = "Inicio"
    if (type === 'userNode') title = "Usuario"
    else if (type === 'botNode') title = "Bot"

    let description = null
    if (type === 'userNode') description = data.suggestedText || data.description || data.keyWords || null
    else if (type === 'botNode') description = data.botMessage

    return (
        <>
            {type !== 'startNode' && <Handle type="target" position={Position.Top} />}
            <div className={`conversation-node ${type} ${selected ? 'active' : ''}`}>
                <div className='title'>
                    <div>
                        <p>{title}</p>
                    </div>
                    <button
                        onClick={(event) => {
                            event.preventDefault();
                            data.openContextMenu(event, node);
                        }}
                    >
                        <i className="k-icon k-i-more-horizontal"></i>
                    </button>
                </div>
                {
                    description &&
                    <div className='description'>
                        <p>{description}</p>
                    </div>
                }
            </div>
            <Handle type="source" position={Position.Bottom} />
        </>
    );
}